import * as purchaseConstants from './constants';

/**
 * @param {Object} purchase
 * @param {string} purchase.status
 * @param {string} purchase.paymentPlanStatus
 * @return {boolean}
 */
export function isPurchaseActive(purchase) {
  const activePurchaseStatuses = [
    purchaseConstants.PURCHASE_STATUS_PAYMENT_CHARGED,
    purchaseConstants.PURCHASE_STATUS_DISPUTE_PURCHASE,
    purchaseConstants.PURCHASE_STATUS_PAUSE_PAYMENTS_CHARGING
  ];
  const activePaymentPlanStatuses = [
    purchaseConstants.PAYMENT_PLAN_STATUS_PENDING_PAYMENTS,
    purchaseConstants.PAYMENT_PLAN_STATUS_ON_SCHEDULE,
    purchaseConstants.PAYMENT_PLAN_STATUS_LATE,
    purchaseConstants.PAYMENT_PLAN_STATUS_CHARGE_FAILED
  ];

  if (activePurchaseStatuses.indexOf(purchase.status) >= 0) {
    if (activePaymentPlanStatuses.indexOf(purchase.paymentPlanStatus) < 0) {
      return false;
    }
    return true;
  }
  return false;
}

export function getPurchaseInActiveReason(purchase) {
  const inActivePurchaseStatuses = {
    [purchaseConstants.PURCHASE_STATUS_CANCELED_AFTER_PURCHASE]: 'purchase.inactive.reason.canceled'
  };
  const inActivePaymentPlanStatuses = {
    [purchaseConstants.PAYMENT_PLAN_STATUS_DEFAULT]: 'purchase.inactive.reason.default',
    [purchaseConstants.PAYMENT_PLAN_STATUS_PAID_OFF]: 'purchase.inactive.reason.paid'
  };

  if (inActivePurchaseStatuses[purchase.status]) {
    return inActivePurchaseStatuses[purchase.status];
  }

  if (inActivePaymentPlanStatuses[purchase.paymentPlanStatus]) {
    return inActivePaymentPlanStatuses[purchase.paymentPlanStatus];
  }

  return null;
}

export function getPurchaseMergedStatus(purchase) {

  switch (purchase.status) {

    case purchaseConstants.PURCHASE_STATUS_CANCELED_AFTER_PURCHASE:
      return purchaseConstants.PURCHASE_STATUS_MERGED_CANCELED;

    case purchaseConstants.PURCHASE_STATUS_DISPUTE_PURCHASE:
      return purchaseConstants.PURCHASE_STATUS_MERGED_DISPUTE;

  }

  switch (purchase.paymentPlanStatus) {

    case purchaseConstants.PAYMENT_PLAN_STATUS_LATE:
      return purchaseConstants.PURCHASE_STATUS_MERGED_LATE;

    case purchaseConstants.PAYMENT_PLAN_STATUS_DEFAULT:
      return purchaseConstants.PURCHASE_STATUS_MERGED_DEFAULT;

    case purchaseConstants.PAYMENT_PLAN_STATUS_PAID_OFF:
      return purchaseConstants.PURCHASE_STATUS_MERGED_PAID;

    case purchaseConstants.PAYMENT_PLAN_STATUS_ON_SCHEDULE:
    case purchaseConstants.PAYMENT_PLAN_STATUS_PENDING_PAYMENTS:
    case purchaseConstants.PAYMENT_PLAN_STATUS_CHARGE_FAILED:
      if (purchase.status === purchaseConstants.PURCHASE_STATUS_PAYMENT_CHARGED) {
        return purchaseConstants.PURCHASE_STATUS_MERGED_ON_SCHEDULE;
      }
  }

  return purchaseConstants.PURCHASE_STATUS_MERGED_UNKNOWN;


}

export function getNextPayment(payments) {

  const nextPaymentStatuses = ['next', 'pending'];
  for (const payment of payments) {
    if (nextPaymentStatuses.indexOf(payment.status.toLowerCase()) >= 0) {
      return payment;
    }
  }

  return null;
}

export function getSumLatePaymentsAmount(payments) {
  return payments.reduce((sum, payment) => {
    if (payment.status.toLowerCase() === 'late') {
      return sum + payment.amount;
    }
    return sum;
  }, 0);
}



// WEBPACK FOOTER //
// ./src/purchases/helpers.js